export const initialState = {
  kpiIndicators: [],
  isSaving: false,
  isDirty: false
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "OnInitState":
      return onInitState(state, action);
    case "OnPropertyChange":
      return onPropertyChange(state, action);
    case "OnSaveStarted":
      return onSaveStarted(state, action);
    case "OnSaveSucceeded":
      return onSaveSucceeded(state, action);
    case "OnSaveFailed":
      return onSaveFailed(state, action);
    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const { kpiIndicators } = action;
  return {
    ...state,
    kpiIndicators
  };
};

const onPropertyChange = (state, action) => {
  const { index, value } = action;
  return {
    ...state,
    kpiIndicators: Object.assign([...state.kpiIndicators], {
      [index]: {
        ...state.kpiIndicators[index],
        indicatorValue: value
      }
    }),
    isDirty: true
  };
};

const onSaveStarted = (state, _action) => {
  return {
    ...state,
    isSaving: true
  };
};

const onSaveSucceeded = (state, action) => {
  const { kpiIndicators } = action;
  return {
    ...state,
    isSaving: false,
    isDirty: false,
    kpiIndicators
  };
};

const onSaveFailed = (state, _action) => {
  return {
    ...state,
    isSaving: false
  };
};
